import type * as lazyIndex from "./lazyIndex";
import getFolderData from "owa-mail-actions/lib/getFolderData";
import { LazyModule, registerLazyOrchestrator } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "FolderOrchestration" */ "./lazyIndex"), { name: "FolderOrchestration" });

// Register orchestrators
registerLazyOrchestrator(getFolderData, lazyModule, m => m.getFolderDataOrchestrator);
